<template>
    <div class="score-history__item">
        <div class="column"><div class="write-on">Нарахування</div></div>
        <div class="column">{{ item.createdAt }}</div>
        <div class="column">{{ item.userFullName }}</div>
        <div class="column"><div class="write-on-amount">{{ item.amountAutolawyer }}</div></div>
        <div class="column">{{ item.currentAutolawyerAmount }}</div>
        <div class="column"><span>Продукт:</span> Автоюрист ({{ item.mtsbuCode }})</div>
        <div class="column"><span>СК:</span> {{ item.company }}</div>
        <div class="column"><span>Джерело:</span> Автоповнення</div>
        <div class="column"><span>ID транзакції:</span> {{ item.id }}</div>
    </div>
</template>

<script>
export default {
    name: 'RowBlockInsuranceCommissionAutolawyer',
    props: {
        item: {
            type: Object,
            default: () => {
                return {
                    id: null,
                    amount: null,
                    amountDgo: null,
                    createdAt: null,
                    currentAmount: null,
                };
            },
        },
    },
}
</script>
